<template>
    <div>
        <p>Texte - petit</p>

        <b-textarea v-model="text_small"></b-textarea>

        <p>Texte - grand</p>

        <b-textarea v-model="text_big"></b-textarea>
    </div>

</template>

<script>

    export default {
        name: "textBuilder",
        props: {
            params: {}
        },
        data: function () {
            return {
                text_small: "",
                text_big: ""
            };
		},
		methods: {
            async save()
            {
                return {
                    text_small: this.text_small,
                    text_big: this.text_big
                }
            },
            async load(data)
            {
                this.text_small = data.text_small;
                this.text_big = data.text_big;
            }
		},
		mounted: function () {
            if (this.params)
                this.load(this.params)
		},
    }


</script>